import { Link } from 'react-router-dom';
import {React} from "react";
import { PortableText } from '@portabletext/react';

const serializers = {
  marks: {
    link: ({children, value}) => {
      const rel = !value.href.startsWith('/') ? 'noreferrer noopener' : undefined
      const target = '_blank'
      const className = 'link'
      return (
        <a href={value.href} rel={rel} target={target} className={className}>
          {children}
        </a>
      )
    },
  },
};
 
// static pages as a component
const About = ({aboutData})  => {
    return(
        <section className="about bg-pink page_module">
            <div className="container">
                <div className="row align-items-center text-center-xs">
                    <div className="col-12 col-lg-6">
                        <img className="img-fluid" src={aboutData.aboutImage} alt={aboutData.aboutTitle}/>
                    </div>
                    <div className="col-12 col-lg-5">
                        <div className="heading mb-40">
                            <p className="heading-subtitle">{aboutData.aboutSubTitle}</p>
                            <h2 className="heading-title">{aboutData.aboutTitle}</h2>
                            <span className="heading-desc"> <PortableText value={aboutData.aboutDesHTML} components={serializers} ></PortableText></span>
                           
                        </div>
                        <Link to={`/${aboutData.slug}`} state={{ aboutData: aboutData }} className="btn btn--bordered btn--primary">read more</Link>
                    </div>
                </div>
            </div>
        </section>   
    );
}

export default About;